<ng-template #content let-modal>
    <app-loading-spinner *ngIf="!this.data"></app-loading-spinner>
    <div *ngIf="this.data" class="d-flex justify-content-between text-center container">
        <div>
            <div class="detail-header">
                <b>Total students</b>
            </div>
            <div>
                {{ data.TotalStudents }}
            </div>
        </div>
        <div>
            <div class="detail-header">
                <b>Logged in</b>
            </div>
            <div>
                {{ data.StudentsThatHaveStarted }}
            </div>
        </div>
        <div>
            <div class="detail-header">
                <b>Completed unit 1</b>
            </div>
            <div>
                {{ data.StudentsThatHaveCompletedFirstUnit }}
            </div>
        </div>
        <div>
            <div class="detail-header">
                <b>Completed unit 1 in 3 weeks</b>
            </div>
            <div>
                {{ data.StudentsThatHaveCompletedFirstUnitWithinThreeWeeks }}
            </div>
        </div>
        <div>
            <div class="detail-header">
                <b>Average days to complete unit 1</b>
            </div>
            <div>
                {{ data.AverageDaysToCompleteFirstUnit }}
            </div>
        </div>
    </div>
</ng-template>

<button ngbTooltip="North Star Report" class="btn north-star" (click)="openForNew()"><img src="assets/North_Star.png"></button>